<script>

import {
  authMethods,
  notificationMethods,
} from "@/state/helpers";

import appConfig from "@/app.config";

/**
 * Login component
 */
export default {
  page: {
    title: "Reset Password",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  data() {
    return {
      form: {
        password: "",
        password_confirmation: "",
      },
      submitted: false,
       loader: false,
      showPassword: false,
      showConfirmPassword: false,
      authError: '',
      isAuthError: false,
      rules: {
        password: [
          v => !!v || 'Password is required.',
          v => (v && v.length >= 3) || 'First name must be least 6 characters.',
        ],
        password_confirmation: [
          v => !!v || 'Password must be confirmed.',
          v => (v && v === this.form.password) || 'Passwords don\'t match.',
        ],
      }
    };
  },
  computed: {
    notification() {
      return this.$store ? this.$store.state.notification : null;

    },
    
   
    checkLoader(){
      return this.loader
    }

  },
  methods: {
    ...authMethods,
    ...notificationMethods,
    // and password they provided.
    submitNewPassword() {
      if (this.validate()) {
         this.loader = true;
        this.submitted = true;
        this.authError = '';

        this.resetPassword({token: this.$route.params.token, payload: this.form})
            // eslint-disable-next-line no-unused-vars
            .then(() => {
              this.reset();
              this.resetValidation()
              this.submitted = false;
              this.isAuthError = false;
              this.authError = '';
               this.loader = false;
              // Redirect to the originally requested page, or to the home page
              this.$router.push(
                  {
                    name: "login",
                  }
              );
            })
            .catch(err => {
              this.submitted = false;
              this.authError = 'Error! try again later';
              if ('response' in err) {
                if (err.response.status === 422) {
                  this.authError = '';
                  const errors = err.response.data;
                  Object.values(errors).forEach(validations => {
                    validations.forEach(validation => {
                      this.authError += `${validation}<br>`;
                    })
                  })
                } else if (err.response.status !== 500
                    || ('data' in err.response.data && 'message' in err.response.data.data)
                ) {
                  this.authError = err.response.data.data.message;
                }
              }
              this.isAuthError = true;
            })
      }
    },
    validate () {
      return this.$refs.form.validate()
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
  },
};
</script>

<template>
  <div class="navy fill-height" id="forgotPassword">
    <v-container :class="$vuetify.breakpoint.mobile ? 'fill-height' : ''">
      <v-row class="d-flex flex-row justify-center" :class="$vuetify.breakpoint.mobile ? 'align-center' : ''">
        <v-col sm="12" md="4">
          <v-card class="pa-5">
            <v-card-title>
              <img src="@/assets/images/logo-dark.png" alt="WesStore" width="100%">
            </v-card-title>
            <v-card class="mb-3 message pa-3" outlined>
              Please enter your new password and confirm it.
            </v-card>
            <v-form ref="form" @submit.prevent="submitNewPassword" lazy-validation>
              <v-container>
                <v-text-field
                    v-model="form.password"
                    :append-icon=" showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'text': 'password'"
                    label="New Password"
                    @click:append="showPassword = !showPassword"
                    :rules="rules.password"
                ></v-text-field>
                <v-text-field
                    v-model="form.password_confirmation"
                    :append-icon=" showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showConfirmPassword ? 'text': 'password'"
                    label="Confirm Password"
                    @click:append="showConfirmPassword = !showConfirmPassword"
                    :rules="rules.password_confirmation"
                ></v-text-field>
                <v-progress-circular
                        v-if="checkLoader"
                        :size="30"
                        color="secondary"
                        indeterminate
                      ></v-progress-circular>
                      <v-btn v-else type="submit" color="primary" block large>

                  <span class="text-transform-none font-weight-bold">Reset password</span>
                </v-btn>
                
              </v-container>
            </v-form>
            <v-row class="d-flex flex-column justify-center align-center text-center">
              <v-col><router-link :to="{ name: 'login' }" class="grey--text text--darken-4">Login</router-link> | <router-link :to="{ name: 'Register' }" class="grey--text text--darken-4">Register</router-link></v-col>
              <v-col>
                <router-link to="/" class="grey--text text--darken-4">
                  <v-icon x-small>mdi-arrow-left</v-icon> Go to WeStore
                </router-link>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-snackbar
        color="red accent-2"
        elavation="24"
        top
        right
        v-model="isAuthError"
    >
      <div v-html="authError"></div>
    </v-snackbar>
  </div>
</template>

<style lang="scss" scoped>
.v-card.message {
  border-left: 4px solid #d81b60;
}

.v-card__title {
  margin-bottom: 100px;
}

.v-card {
  .text-transform-none {
    text-transform: none;
  }
}

.v-footer
{
  display: none !important;
}
</style>
